<template>
    <figure :class="['z-blockquote', { [`z-blockquote--size-${this.size}`]: this.size }]">
        <div
            class="z-blockquote__author-photo"
            v-if="author.photo"
            :style="`background-image: url(${author.photo})`"
        ></div>

        <div class="z-blockquote__wrapper">
            <div class="z-blockquote__body" v-if="!!this.$slots['text'] || text">
                <blockquote v-html="text" v-if="text">
                    <slot name="text"></slot>
                </blockquote>
            </div>
            <div class="z-blockquote__footer" v-if="date || author.name">
                <div
                    class="z-blockquote__author-photo z-blockquote__author-photo--mobile"
                    v-if="author.photo"
                    :style="`background-image: url(${author.photo})`"
                ></div>
                <div class="z-blockquote__footer-wrapper">
                    <div class="z-blockquote__name" v-html="author.name"></div>
                    <div class="z-blockquote__footer-container">
                        <div class="z-blockquote__info-container">
                            <span class="z-blockquote__info" v-html="author.info" />
                            <span
                                class="z-blockquote__footer-divider"
                                v-if="date && author.info"
                            />
                            <span v-if="date" class="z-blockquote__date" v-html="date" />
                        </div>
                        <z-link
                            v-if="link"
                            :href="linkToDetail"
                            custom-icon="arrow"
                            icon-position="right"
                            class="z-blockquote__link-text"
                        >
                            {{ textLink }}
                        </z-link>
                    </div>
                </div>
                <slot name="footer"/>
            </div>
        </div>
    </figure>
</template>

<script>
import { localize } from '@/utils/i18n.js'

export default {
    name: 'z-blockquote',
    props: {
        author: {
            name: String,
            info: String,
            photo: String
        },
        date: {
            type: String
        },
        text: {
            type: String
        },
        size: {
            type: String,
            validator: (prop) => ['s', 'm', 'l'].includes(prop),
            default: 'm'
        },
        link: {
            type: Boolean
        },
        linkToDetail: {
            type: String
        }
    },
    data () {
        return {
            textLink: localize({
                ru: 'Подробнее',
                en: 'More'
            })
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
